import React from 'react';
import { Route, IndexRoute, Redirect } from 'react-router';

import HomePage from 'modules/Home/containers/HomePage';
import HomeFootballLiveMatchesContainer from 'modules/Home/containers/HomeFootballLiveMatchesContainer';
import HomeFootballVidiprinter from 'modules/Home/containers/HomeFootballVidiprinter';
import HomeColumnists from 'modules/Home/containers/HomeColumnists';

import SectionLink from 'modules/Common/components/SectionLink';

import MoreNews from 'modules/News/containers/MoreNews';
import MostReadAll from 'modules/Common/containers/MostReadAll';
import RacingTips from 'modules/Common/containers/RacingTips';
import FootballTips from 'modules/Common/containers/FootballTips';
import HorseRacingNextRaceOff from 'modules/Common/containers/HorseRacingNextRaceOff';
import AdvertWrapper from 'modules/Common/components/AdvertWrapper';
import GooglePublisherTag from 'modules/Common/containers/GooglePublisherTag';
import InsiderMpu from 'modules/Common/containers/InsiderMpu';


const homeRoutes = (
  <Route component={HomePage}>
    <IndexRoute sitemap={{}} components={{
    SectionLink,
    MoreNews,
    MostReadAll,
    HomeFootballLiveMatchesContainer,
    HomeFootballVidiprinter,
    RacingTips,
    FootballTips,
    HorseRacingNextRaceOff,
    HomeColumnists,
    AdvertWrapper,
    GooglePublisherTag,
    InsiderMpu
  }}/>
    <Redirect from="sso/success" to="/" />
  </Route>
)

export default homeRoutes



// WEBPACK FOOTER //
// ./modules/Home/routes.js